import { Component } from 'react'

class LoginRedirectView extends Component {
  render() {
    return null
  }
}

export default LoginRedirectView
